const lockBody = () => {
	document.body.classList.add("overflow-hidden");
};

const unlockBody = () => {
	document.body.classList.remove("overflow-hidden");
};

export default function useScrollBehaviourBody() {
	return {
		lockBody,
		unlockBody,
	};
}
